// Derives a responsive srcset from a single Pexels/Unsplash URL by
// swapping its width param across several breakpoints, so mobile
// devices don't download desktop-sized images.

const setWidth = (url, width) => {
  const u = new URL(url);
  if (u.hostname.includes("pexels.com")) {
    u.searchParams.set("w", width);
    if (!u.searchParams.has("auto")) u.searchParams.set("auto", "compress");
    if (!u.searchParams.has("cs")) u.searchParams.set("cs", "tinysrgb");
  } else if (u.hostname.includes("unsplash.com")) {
    u.searchParams.set("w", width);
    if (!u.searchParams.has("q")) u.searchParams.set("q", "75");
    if (!u.searchParams.has("auto")) u.searchParams.set("auto", "format");
    if (!u.searchParams.has("fit")) u.searchParams.set("fit", "crop");
  } else {
    return url;
  }
  return u.toString();
};

export const buildSrcSet = (url, widths) => {
  if (!url || !/^https:\/\/images\.(pexels|unsplash)\.com\//.test(url)) return undefined;
  return widths.map((w) => `${setWidth(url, w)} ${w}w`).join(", ");
};

export const WIDTHS = {
  hero: [640, 960, 1280, 1600, 1920],
  card: [400, 640, 800],
  thumb: [320, 480, 640],
};
